module.exports = __webpack_public_path__ + "static/media/icon-event__el-terrorismo-islamico-hover.7f988a4f.svg";